import { RECRUITEE_BACKEND } from '@core/environment-legacy/production';

import type { TellentClientSetupEnvironment } from './interface';

export const environment: TellentClientSetupEnvironment = {
  environmentName: 'production',
  angularProdMode: true,
  assetsCdnUrl: 'https://recruitee-assets.s3.eu-central-1.amazonaws.com/tellent-client',
  tellentApiUrl: RECRUITEE_BACKEND.tellentApiUrl,
  tellentAuthUrl: RECRUITEE_BACKEND.tellentAuthUrl,
  tellentAppUrl: RECRUITEE_BACKEND.tellentAppUrl,
  tellentApiWsUrl: RECRUITEE_BACKEND.tellentAppWsUrl,
  reportsApiUrl: RECRUITEE_BACKEND.reportsApiUrl,
  tellentOneDomainUrl: RECRUITEE_BACKEND.tellentOneDomainUrl,
  tellentWebsiteUrl: RECRUITEE_BACKEND.tellentWebsiteUrl,
};
